/* ============================================================
   Banner cookie custom — Adele Chérie
   - Mostra il banner solo finché l'utente non sceglie.
   - Ricorda la scelta in localStorage + cookie (1 anno) => non riappare.
   - Registra il consenso reale via Shopify.customerPrivacy API
     (così i pixel marketing/analytics vengono bloccati/abilitati).
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'ac_cookie_consent';        // 'accepted' | 'declined'
  var MAX_AGE = 60 * 60 * 24 * 365;     // 1 anno (secondi)

  function readCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function writeCookie(name, value) {
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; Max-Age=' + MAX_AGE + '; Path=/; SameSite=Lax' + secure;
  }
  function getChoice() {
    try {
      var v = window.localStorage.getItem(KEY);
      if (v) return v;
    } catch (e) {}
    return readCookie(KEY);
  }
  function saveChoice(v) {
    try { window.localStorage.setItem(KEY, v); } catch (e) {}
    writeCookie(KEY, v);
  }

  /* Registra il consenso lato Shopify (Customer Privacy API). */
  function registerShopifyConsent(granted) {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (err) {
        if (err || !window.Shopify.customerPrivacy) return;
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              marketing: granted,
              analytics: granted,
              preferences: granted,
              sale_of_data: granted ? 'enabled' : 'disabled'
            },
            function () {}
          );
        } catch (e) {}
      }
    );
  }

  function init() {
    var banner = document.querySelector('[data-ac-cookie-banner]');
    if (!banner) return;

    // Se l'utente ha già scelto, non mostrare nulla.
    if (getChoice()) return;

    // Mostra il banner.
    banner.hidden = false;
    // forza reflow per far partire la transizione
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { banner.classList.add('is-visible'); });
    });

    function decide(granted) {
      saveChoice(granted ? 'accepted' : 'declined');
      registerShopifyConsent(granted);
      banner.classList.remove('is-visible');
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        banner.hidden = true;
      };
      banner.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 500); // fallback se transitionend non scatta
    }

    banner.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ac-cookie]');
      if (!btn) return;
      decide(btn.getAttribute('data-ac-cookie') === 'accept');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
